module.exports = __webpack_public_path__ + "img/winner-weekly.7e3afebe.png";